import React from 'react';
import { FooterModel } from '../models/navigation-model';
import { ExternalLink } from './external-link-modal';


export interface Props {
    footer: FooterModel,
}

export const Footer = (props: Props) => {

    return (
        <footer className="footer">
            <div className="footer-upper">
                <div className="footer-primary">{props.footer?.FooterPrimaryLinks?.map((a, idx) => <ExternalLink key={idx} linkUrl={a.LinkUrl} linkText={a.LinkText} newWindow={a.NewWindow} />)}</div>
                <div className="footer-social">{props.footer?.FooterSocialMediaLinks?.map((a, idx) => {
                    const linkTextNode = <><img src={a.IconUrl} alt={a.IconAltText} /><span className="visually-hidden">{a.LinkText}</span></>;
                    return (
                        <ExternalLink key={idx} linkUrl={a.LinkUrl} linkText={linkTextNode} />
                    );
                })}</div>
            </div>
            <div className="footer-lower">
                <div className="footer-secondary">{props.footer?.FooterSecondaryLinks?.map((a, idx) => <ExternalLink key={idx} linkUrl={a.LinkUrl} linkText={a.LinkText} newWindow={a.NewWindow} />)}</div>
                <div className="footer-copyright">{props.footer?.FooterCopyRightTexts}</div>
            </div>
        </footer>
    );
};